import { useSelector } from "react-redux";
import LocalTrack from "./LocalTrack";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { memo } from "react";

function LocalTracks() {
  const { localTracks, chimeEnabled, boothmatesMute } = useSelector(
    (state) => state.connection
  );

  let isVideoExist = localTracks.filter((track) => track.getType() === "video");
  let audioTrack = localTracks.find((track) => track.getType() === "audio");

  if (!isVideoExist.length || !localTracks.length) {
    return (
      <>
        <LazyLoadImage
          className="video-thumb noImage-thumb img-fluid mic-status-video"
          id={`local-video-thumb-0001`}
          alt="video"
          src="/media/noPicture.svg"
          effect="blur"
        />
        <div className="video-controls">
          <i
            className={`${
              chimeEnabled
                ? "fa-solid fa-bell-on"
                : "fa-solid fa-bell-slash text-danger"
            }`}
          ></i>
          <i
            className={` ${
              boothmatesMute
                ? "fa-solid fa-ear-deaf text-danger"
                : "fa-solid fa-ear "
            }`}
          ></i>
          <i
            className={` ${
              audioTrack == undefined || audioTrack?.isMuted()
                ? "fa-solid fa-microphone-slash"
                : "fa-solid fa-microphone text-danger"
            }`}
          ></i>
        </div>
      </>
    );
  }

  return localTracks.map((localtrack, index) => {
    return (
      <LocalTrack
        track={localtrack}
        isAudioMuted={audioTrack?.isMuted()}
        chimeEnabled={chimeEnabled}
        boothmatesMute={boothmatesMute}
        key={index}
        index={index}
      />
    );
  });
}

export default memo(LocalTracks);
